export const getMatchTreatmentToDisplay = match =>
  [
    match?.other?.reason,
    ...match?.other?.subReasons || [],
    match?.other?.otherReason,
  ]
    .filter(Boolean)
    .join(', ');

export const getMatchInsuranceToDisplay = match =>
  [match?.other?.insurance?.provider, match?.other?.insurance?.plan]
    .filter(Boolean)
    .join(' ');
